<template>
  <div>
    <!-- begin breadcrumb -->
    <ol class="breadcrumb float-xl-right">
      <li class="breadcrumb-item"><a :href="'/task'">Task</a></li>
      <li v-if="$route.params.level" class="breadcrumb-item">
        <a :href="'/task/' + $route.params.id"
          >{{ $route.params.level | capitalize }} tasks</a
        >
      </li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      Task
      <small
        >Make things happen. Move from planning to preparation and
        implementation. Export and share your plans to your teams’ “things to
        do” -tasks.</small
      >
    </h1>
    <!-- end page-header -->
    <router-view
      v-bind:activeEvent="activeEvent"
      v-bind:storyboards="storyboards"
      v-bind:storyboard="storyboard"
      v-bind:stages="stages"
      v-bind:stage="stage"
      v-bind:steps="steps"
      v-bind:categories="categories"
      v-bind:items="items"
      v-bind:scriptItems="scriptItemsBelongingToStageAndStoryboard"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Task',
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  computed: {
    ...mapState('storyboard', ['storyboards', 'storyboard']),
    ...mapState('stage', ['stages', 'stage']),
    ...mapState('step', ['steps', 'step']),
    ...mapState('event', ['activeEvent']),
    ...mapState('item', ['items', 'item']),
    ...mapState('category', ['categories', 'category']),
    ...mapState('scriptitem', ['scriptItems', 'scriptItem']),
    scriptItemsBelongingToStageAndStoryboard() {
      if (!this.scriptItems) {
        return false
      }
      const filtered = this.scriptItems.filter((scriptItem) => {
        if (!scriptItem.step) {
          return false
        }
        const stage = this.stages.find(
          (stage) => stage.id === scriptItem.step.stage
        )
        if (!stage) {
          return false
        }
        const storyboard = this.storyboards.find(
          (storyboard) => storyboard.id === stage.storyboard
        )
        if (!storyboard) {
          return false
        }
        return true
      })
      return filtered
    }
  },
  methods: {
    ...mapActions('storyboard', ['getStoryboards', 'getStoryboard']),
    ...mapActions('stage', ['getStages', 'getStage']),
    ...mapActions('step', ['getSteps', 'getStep']),
    ...mapActions('item', ['getItems', 'getItem']),
    ...mapActions('category', ['getCategories', 'getCategory']),
    ...mapActions('scriptitem', ['getScriptItems', 'getScriptItem'])
  },
  mounted() {
    this.getStoryboards(this.activeEvent.id)
    this.getStages(this.activeEvent.id)
    this.getSteps(this.activeEvent.id)
    this.getItems(this.activeEvent.id)
    this.getCategories(this.activeEvent.id)
    this.getScriptItems(this.activeEvent.id)
  }
}
</script>
